import { LeftOutlined } from '@ant-design/icons'
import { Button, Flex, Form, Tabs } from 'antd'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { useCounterpartServiceGetCounterpartEndpoint } from 'src/api/queries'
import { LegalEntityStatus, Permissions } from 'src/api/requests'
import { LoadingScreen, PageBreadcrumbs } from 'src/components'
import { useUser } from 'src/hooks'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

import {
  ContractList,
  CounterPartDetails,
  TemplateContractsList
} from '../components'

export const CounterPartsDetailsPage = () => {
  const { id } = useParams()
  const { t } = useLocales()
  const navigate = useNavigate()

  const [form] = Form.useForm()

  const { hasPermission } = useUser()
  const { data, isLoading } = useCounterpartServiceGetCounterpartEndpoint({
    id: String(id)
  })

  const onBackClick = () => {
    navigate(paths.counterpart.root)
  }

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        ...data,
        status: data.status === LegalEntityStatus.ACTIVE
      })
    }
  }, [data])

  if (isLoading) {
    return <LoadingScreen />
  }

  return (
    <PageBreadcrumbs
      title={data?.name}
      items={[
        {
          title: t('counterparts.title'),
          path: paths.counterpart.root
        },
        {
          title: String(data?.name)
        }
      ]}
      extra={
        <Button
          type="primary"
          onClick={() => navigate(paths.counterpart.edit(String(id)))}
        >
          {t('common.edit')}
        </Button>
      }
    >
      <Flex vertical gap={24}>
        <Button
          icon={<LeftOutlined />}
          className="fit-content"
          onClick={onBackClick}
        >
          {t('common.back')}
        </Button>

        <CounterPartDetails form={form} isDisabled />

        <Tabs
          items={[
            {
              label: t('counterparts.contracts'),
              key: 'contracts',
              children: <ContractList isCounterpart />
            },
            ...(hasPermission(Permissions.TEMPLATES_MENU_VIEW_TEMPLATES)
              ? [
                  {
                    label: t('counterparts.draft'),
                    key: 'draft',
                    children: <TemplateContractsList isCounterpart />
                  }
                ]
              : [])
          ]}
        />
      </Flex>
    </PageBreadcrumbs>
  )
}
